var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3206",
    "data-name": "Rectangle 3206",
    width: 66.44,
    height: 55.751,
    fill: "#55b864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706",
    transform: "translate(-1425 -1916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    transform: "translate(1425 1916)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5958",
    "data-name": "Group 5958",
    transform: "translate(1443 1940)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5957",
    "data-name": "Group 5957",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M0,10.354C.811,7.442,3.1,5.985,5.576,4.765A41.438,41.438,0,0,1,16.893,1.39,96.454,96.454,0,0,1,44.917.708,56.211,56.211,0,0,1,59.074,3.974a16.416,16.416,0,0,1,5.479,3.26,5.747,5.747,0,0,1,1.881,4.384q-.045,17.156.006,34.312A6.024,6.024,0,0,1,64.178,50.8a20.783,20.783,0,0,1-7.288,3.7c-1.373.447-2.777.806-4.179,1.157a2.208,2.208,0,0,1-2.9-2.29q-.009-6.693,0-13.387v-.818c-1.4-.211-2.773-.433-4.156-.6-.133-.016-.36.252-.45.435a13.26,13.26,0,0,1-23.918.116c-.227-.479-.464-.635-.977-.541-1.208.223-2.425.4-3.709.608v.731q0,6.628,0,13.257c0,1.964-1.178,2.9-3.078,2.446A35.511,35.511,0,0,1,4.821,52.54a10.058,10.058,0,0,1-3.47-2.669A18.834,18.834,0,0,1,0,47.4V10.354M49.814,36.913v-.819q0-7.7,0-15.4a2.327,2.327,0,0,1,2.063-2.621c1.088-.272,2.185-.519,3.257-.846a21.979,21.979,0,0,0,7.255-3.338C64.829,12,64.8,10.148,62.351,8.263a19.244,19.244,0,0,0-5.789-2.841,68.965,68.965,0,0,0-19.055-3.1A91.542,91.542,0,0,0,17.042,3.6,41.491,41.491,0,0,0,6.653,6.715,10.481,10.481,0,0,0,3.011,9.256a2.467,2.467,0,0,0,.1,3.753,13.846,13.846,0,0,0,2.857,2.1,32.7,32.7,0,0,0,8.472,2.946A2.357,2.357,0,0,1,16.6,20.785q0,7.668,0,15.336v.8l3.647-.588A13.343,13.343,0,0,1,31.861,20a12.646,12.646,0,0,1,9.875,3.055c4.07,3.518,5.4,8.025,4.439,13.276l3.639.579M14.356,53.543c.018-.181.042-.3.042-.429q0-16.147.006-32.294c0-.415-.143-.544-.528-.633-1.135-.261-2.268-.542-3.382-.878a24.118,24.118,0,0,1-7.826-3.641c-.126-.1-.263-.177-.434-.292-.011.164-.022.25-.022.336q0,15.367,0,30.734a2.74,2.74,0,0,0,.779,1.938,9,9,0,0,0,1.4,1.251c3.009,2.074,6.456,3.027,9.975,3.907M64.209,15.312A21.663,21.663,0,0,1,56.9,19c-1.375.438-2.777.8-4.183,1.131-.549.128-.7.345-.7.9q.023,15.883.007,31.765v.741A32.624,32.624,0,0,0,60.449,50.6a17.6,17.6,0,0,0,2.683-1.9,3.151,3.151,0,0,0,1.089-2.594q-.03-15.006-.012-30.011ZM22.156,33.178A11.054,11.054,0,1,0,33.368,22.192,11.082,11.082,0,0,0,22.156,33.178",
    transform: "translate(0 0)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M76.041,30.529c-.013.663-.436,1.007-1.328,1.135-1.345.193-2.7.356-4.028.629-1.773.364-3.528.82-5.29,1.24a1.114,1.114,0,0,1-1.433-.643,1.068,1.068,0,0,1,.845-1.473q3.779-.88,7.577-1.679a22.7,22.7,0,0,1,2.374-.316,1.079,1.079,0,0,1,1.284,1.107",
    transform: "translate(-52.811 -24.317)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M250.451,28.491c2.809.571,5.62,1.135,8.427,1.717.548.114,1.086.279,1.621.447a1.087,1.087,0,0,1,.836,1.38,1.107,1.107,0,0,1-1.43.744q-4.3-.909-8.609-1.8c-.379-.078-.774-.084-1.153-.165a1.063,1.063,0,0,1-.908-1.215,1.367,1.367,0,0,1,1.216-1.111",
    transform: "translate(-206.042 -23.554)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M72.608,59.213a1.107,1.107,0,0,1-.933,1.091q-3.228.812-6.458,1.616a1.1,1.1,0,0,1-1.423-.768,1.052,1.052,0,0,1,.806-1.339c2.163-.582,4.333-1.145,6.513-1.659a1.107,1.107,0,0,1,1.494,1.059",
    transform: "translate(-52.704 -48.04)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M269.683,57.57c1.84.463,3.682.921,5.519,1.392a11.714,11.714,0,0,1,1.3.412,1.1,1.1,0,1,1-.671,2.095q-3.233-.805-6.463-1.624a1.082,1.082,0,0,1-.895-1.236,1.225,1.225,0,0,1,1.214-1.038",
    transform: "translate(-221.941 -47.595)",
    fill: "#55b864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M159.638,160.408c0-1.71-.006-3.42,0-5.13.006-1.3.749-1.783,1.9-1.211,3.514,1.754,7.021,3.521,10.535,5.273a1.253,1.253,0,0,1,.857,1.112,1.23,1.23,0,0,1-.836,1.125c-3.533,1.763-7.059,3.54-10.592,5.3-1.077.537-1.849.058-1.858-1.146-.013-1.775,0-3.549,0-5.324m9.714.054-7.435-3.723v7.453l7.435-3.73",
    transform: "translate(-131.974 -127.174)",
    fill: "#55b864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.84697eee3188e5cdd228a5a791d49969.svg";
export { ForwardRef as ReactComponent };